import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "uk-modal-dialog" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("button", {
  class: "uk-modal-close-default",
  type: "button",
  "data-uk-close": ""
}, null, -1)
const _hoisted_3 = { class: "uk-modal-header" }
const _hoisted_4 = { class: "uk-modal-body" }
const _hoisted_5 = { class: "uk-modal-footer uk-text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    ref: "loadAdhocDialog",
    class: _normalizeClass({'uk-modal-container': _ctx.shouldExpand}),
    "data-uk-modal": ""
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "title")
      ]),
      _createElementVNode("div", _hoisted_4, [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _createElementVNode("div", _hoisted_5, [
        _renderSlot(_ctx.$slots, "buttons")
      ])
    ])
  ], 2))
}